export const PERMISSION = { USERS_UPDATE: 'Users.Update' };
export const ROLE = { ADMIN: 'Admin User', OPS: 'Operation User', TECH: 'Tech User' };

// Mirrors admin-corev2's permissionMiddleware: case-insensitive match on the
// user's role[].permission[].id, read from the sessionStorage `user` (written at
// login/renew — the /profile response does not carry role/permission).
export function hasPermission(scope) {
	try {
		const userStr = sessionStorage.getItem('user');
		if (!userStr) return false;
		const roles = JSON.parse(userStr)?.role || [];
		return roles.some((r) =>
			(r.permission || []).some((p) => p?.id?.toLowerCase() === scope.toLowerCase())
		);
	} catch {
		return false;
	}
}

export const hasUsersUpdatePermission = () => hasPermission(PERMISSION.USERS_UPDATE);

// True only when the user holds at least one role and EVERY role is in `names`,
// so a multi-role user keeps whatever any of their other roles allows.
export function hasOnlyRoles(...names) {
	try {
		const roles = JSON.parse(sessionStorage.getItem('user'))?.role || [];
		return roles.length > 0 && roles.every((r) => names.includes(r?.name));
	} catch {
		return false;
	}
}
